import TomSelect from "tom-select";
import {TomSettings} from "tom-select/src/types";
import {TomLoadCallback} from "tom-select/dist/types/types";
import {MuWidget} from "mu-widget/lib/MuWidget";
import {arrayDiff} from "../Utils";

export class UiTomSelect extends MuWidget
{
	public maxItems: number|null = null;
	public valueField: string = "id";
	public labelField: string = "name";
	public searchField: string[] = ["name"];
	// @ts-ignore
	public tom: TomSelect;
	public optionLoader: ((escapeQuery: string|string[], callback:TomLoadCallback)=>void)|null = null;

	public get value() {
		return this.tom.getValue();
	}

	public set value(v) {
		this.tom.setValue(v);
	}

	public get valueOption(): any|null {
		const v = this.value;
		// @ts-ignore
		return v ? this.tom.options[v] : null;
	}

	muFetchData(): any {
		return this.value;
	}

	async muBindData(data: any): Promise<any> {
		if (this.multiple) {
			if (data) {
				let value: any[] = [];
				for (const v of data) {
					if (!v || ['string', 'number'].includes(typeof v)) value.push(v);
					else {
						this.tom.addOption(v);
						value.push(v[this.valueField]);
					}
				}
				if (value.length) {
					const existsIds = Object.keys(this.tom.options);
					value = value.map(v => v.toString());
					const missing = arrayDiff(value, existsIds);
					if (missing.length) {
						if (this.optionLoader) {
							this.optionLoader(missing, newOptions => {
								this.replaceOptions(newOptions);
								this.value = value;
							});
						}
					} else this.value = value;
				}
			} else this.value = [];
		} else {
			if (!data || ['string', 'number'].includes(typeof data)) {
				const val = data;
				if (!this.tom.options[val]) {
					this.tom.addOption({
						[this.valueField]: val,
						[this.labelField]: "... " + val,
					});
					if (this.optionLoader) {
						this.optionLoader([val], newOptions => {
							this.replaceOptions(newOptions);
						});
					}
				}
				this.value = val;
			} else {
				this.replaceOption(data);
				this.value = data[this.valueField];
			}
		}
	}

	public bindItems(items: any[]|Record<string, string | any>) {
		if (Array.isArray(items)) {
			for(const item of items)
				this.tom.addOption(item);
		} else {
			for(const k in items) {
				let item = items[k];
				this.tom.addOption((typeof item === "string")
					? {
						id: k,
						title: item,
					}
					: item
				);
			}
		}
	}

	beforeIndex() {
		this.container.innerHTML += '<select mu-id="input"' + (this._multiple ? " multiple" : "") + '></select>';
	}

	afterIndex() {
		// this.init();
	}

	private _multiple: boolean = false;

	set multiple(multiple: boolean) {
		this._multiple = multiple;
		if (this.ui.input) this.ui.input.multiple = multiple;
	}

	get multiple() { return this._multiple; }

	public init() {
		const opts: Partial<TomSettings> = {
			maxItems: this.multiple ? this.maxItems : 1,
			valueField: this.valueField,
			labelField: this.labelField,
			searchField: this.searchField,
		};
		if (this.muTemplates.item) {
			const render = (item: any, escape: (s:string)=>string): HTMLElement => {
				const itemWidget = this.muWidgetFromTemplate("item", null, item);
				itemWidget.muBindData(item);

				return itemWidget.container as HTMLElement;
			}
			// @ts-ignore
			opts.render = {
				option: render,
				item: render,
			}
		}
		if ((this as any).optionLoader) opts.load = (escapeQuery: string, callback) => (this as any).optionLoader(escapeQuery, callback);
		this.tom = new TomSelect(this.ui.input, opts);
	}

	public replaceOption(option: any) {
		if (this.tom.options[option[this.valueField]]) {
			this.tom.updateOption(option[this.valueField], option);
		} else {
			this.tom.addOption(option);
		}
	}

	public replaceOptions(options: any[]) {
		for(const option of options)
			this.replaceOption(option);
	}
}